module.exports = __webpack_public_path__ + "static/media/jaels-creations-mobile-2.8cfa7274.png";